'use strict';

var bsscomponenti = angular.module("bss.componenti", [])
        .component("bssledio", require("./bssledio/scripts/BSSLedIO"));

module.exports = bsscomponenti;